.xm-full-screen-btn {
  &.xm-full-screen-btn-on {
    color: var(--ant-color-primary);

    &:hover {
      color: var(--ant-color-primary-hover);
    }
  }

  .ant-btn-icon {
    justify-content: center;

    >svg {
      display: block;
      vertical-align: 0;
    }
  }
}